import { z } from "zod"

export const MAX_ONBOARDING_LANGUAGES = 31
export const DEFAULT_ONBOARDING_LANGUAGES = ["en"] as const

export const ONBOARDING_LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "uk", label: "Ukrainian" },
  { value: "bg", label: "Bulgarian" },
  { value: "de", label: "German" },
  { value: "ru", label: "Russian" },
  { value: "es", label: "Spanish" },
  { value: "fr", label: "French" },
  { value: "it", label: "Italian" },
  { value: "pt", label: "Portuguese" },
  { value: "ja", label: "Japanese" },
  { value: "ko", label: "Korean" },
  { value: "zh", label: "Chinese" },
  { value: "ar", label: "Arabic" },
  { value: "hr", label: "Croatian" },
  { value: "cs", label: "Czech" },
  { value: "da", label: "Danish" },
  { value: "nl", label: "Dutch" },
  { value: "fil", label: "Filipino" },
  { value: "fi", label: "Finnish" },
  { value: "el", label: "Greek" },
  { value: "hi", label: "Hindi" },
  { value: "hu", label: "Hungarian" },
  { value: "id", label: "Indonesian" },
  { value: "ms", label: "Malay" },
  { value: "no", label: "Norwegian" },
  { value: "pl", label: "Polish" },
  { value: "ro", label: "Romanian" },
  { value: "sk", label: "Slovak" },
  { value: "sv", label: "Swedish" },
  { value: "ta", label: "Tamil" },
  { value: "tr", label: "Turkish" },
  { value: "vi", label: "Vietnamese" },
] as const

const SUPPORTED_ONBOARDING_LANGUAGE_CODES = ONBOARDING_LANGUAGE_OPTIONS.map(
  (language) => language.value,
) as [string, ...string[]]
const LanguageCodeSchema = z.enum(SUPPORTED_ONBOARDING_LANGUAGE_CODES)

export const SignupOnboardingLanguagesSchema = z
  .array(LanguageCodeSchema)
  .min(1, "Choose at least one language.")
  .max(
    MAX_ONBOARDING_LANGUAGES,
    `Choose no more than ${MAX_ONBOARDING_LANGUAGES} languages.`,
  )
  .refine(
    (languages) => new Set(languages).size === languages.length,
    "Each selected language must be unique.",
  )

export function getOnboardingLanguageName(code: string): string {
  return (
    ONBOARDING_LANGUAGE_OPTIONS.find((language) => language.value === code)
      ?.label ?? code.toUpperCase()
  )
}
